const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    sortOrder:'',
    queryString: '',
    type:''
};

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        sortSelected: (state, action) => {
            state.sortOrder = action.payload;
        },
        typeSelected: (state, action) => {
            state.type = action.payload;
        },
        queryStringChanged: (state, action) => {
            state.queryString = action.payload;
        },
        clearFilter: (state)=>{
            state.sortOrder='';
            state.queryString = '';
            state.type=''
        }
    },
});

export default filterSlice.reducer;
export const { sortSelected, queryStringChanged, clearFilter,typeSelected} = filterSlice.actions;
